import React,{ Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state={ 
            search_term: '',
            start:'',
            end: '', 
            startDate:null,
            endDate:null,
        }; 
    }
 
    handleChange=(date)=>{
        this.setState({
            startDate: date,
            start:this.getDate(date,1)
        });
    }
  
    handleChangeEnd=(date)=>{ 
        this.setState({
            endDate: date,
            end:this.getDate(date,2)
        });
    }

    getDate=(date,day)=>{ 
        if(!date)
            return '';
            
        var slectedDate = new Date(date);
        slectedDate.setDate(slectedDate.getDate() + day); 
        return Date.parse(slectedDate) / 1000;
    }

    searchTerm=(e)=>{
        this.setState({
            search_term: e.currentTarget.value 
        }); 
    }
 
  
    applyFilter=()=>{
       
        this.props.filterSearch({search_term:this.state.search_term,start:this.state.start?this.state.start:'',end:this.state.end?this.state.end:''});
       
    } 

    render() {
        let {addbtn,CustomButton,CustomFilter,CustomFilters,backbtn }=this.props; 
 
        return <div>
            {
                CustomFilters ? <CustomFilters {...this.props}/>:
                    <div className="uk-grid" style={{padding:'8px 0 3px 0'}}>
                        <div className="uk-width-medium-1-5"> 
                            <div className='md-input-wrapper'>
                                <label>From Date</label>
                                <DatePicker selected={this.state.startDate} dateFormat="DD/MM/YYYY" className="datepicker md-input" onChange={this.handleChange} />
                            </div>
                        </div>

                        <div className="uk-width-medium-1-5">
                            <div className='md-input-wrapper'>
                                <label>To Date</label> 
                                <DatePicker selected={this.state.endDate} dateFormat="DD/MM/YYYY" className="datepicker md-input" onChange={this.handleChangeEnd} />
                            </div>
                        </div>

                        <div className="uk-width-medium-1-5"> 
                            <div className='md-input-wrapper'>
                                <label>Search...</label> 
                                <input type="text" id="input1-group2" name="input1-group2" className="md-input" onChange={this.searchTerm} value={this.state.search_term} />
                            </div>
                        </div>
                        <div className="uk-width-medium-1-3" style={{width:'37%'}}> 
                            <div className='md-input-wrapper'>
                                {
                                    CustomFilter && 
                            <CustomFilter {...this.props}/>
                                } 

                                <button style={{float:'left'}} type="button" onClick={this.applyFilter.bind(this)}   className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Search</button>
                                { addbtn && 
                            <Link style={{float:'left',marginLeft:'6px'}} to={`${addbtn}`}> <button type="button"  className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Add</button></Link>
                                } 

                                { backbtn && 
                            <Link style={{float:'left',marginLeft:'6px'}} to={`${backbtn}`}> <button type="button"  className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Back</button></Link>
                                } 
                                {
                                    CustomButton && 
                            <CustomButton {...this.props}/>
                                } 
                            </div>
                        </div>
                    </div>
            }  
        </div>
        ;
    }
}

export default Filter;





// WEBPACK FOOTER //
// ./src/core/Filter.js